import { Component, input } from '@angular/core';

// Ce qui remplace le contenu d'un ecran : chargement, liste vide, erreur.
// Le contenu projete (bouton Reessayer…) s'affiche sous le message.
@Component({
  selector: 'app-state-panel',
  templateUrl: './state-panel.html',
})
export class StatePanel {
  readonly kind = input.required<'loading' | 'empty' | 'error'>();
  readonly title = input.required<string>();
  readonly message = input<string | null>(null);
}
